<div style="display: flex">
  <app-sidebar></app-sidebar>
  <div class="fullscreen">
    <div id="content">
      <mat-drawer-container>
        <mat-drawer-content class="drawer-content-container">
          <router-outlet></router-outlet>
          <div *ngIf="isDashboardRoute()" style="display: flex; flex-direction: column">
            <div class="card-container container-1">
              <mat-card class="link-card card-1">
                <mat-card-content>
                  <a routerLink="/users">
                    <div class="icon-container">
                      <i class="bi bi-people"></i>
                    </div>
                    Utilizatori
                  </a>
                </mat-card-content>
              </mat-card>
              <mat-card class="link-card">
                <mat-card-content>
                  <a routerLink="/tickets">
                    <div class="icon-container">
                      <i class="bi bi-file-text"></i>
                    </div>
                    Tichete
                  </a>
                </mat-card-content>
              </mat-card>
              <mat-card class="link-card">
                <mat-card-content>
                  <a routerLink="/subscriptions">
                    <div class="icon-container">
                      <i class="bi bi-card-list"></i>
                    </div>
                    Abonamente
                  </a>
                </mat-card-content>
              </mat-card>
              <!-- <mat-card class="link-card">
                <mat-card-content>
                  <a routerLink="/parking-agents">
                    <div class="icon-container">
                      <i class="bi bi-person-badge"></i>
                    </div>
                    Agenți de parcare
                  </a>
                </mat-card-content>
              </mat-card> -->
              <!-- <mat-card class="link-card">
                <mat-card-content>
                  <a routerLink="/riparian-requests">
                    <div class="icon-container">
                      <i class="bi bi-building"></i>
                    </div>
                    Cerere de parcare riverani
                  </a>
                </mat-card-content>
              </mat-card> -->
            </div>
            <div class="card-container container-2">
              <!-- <mat-card class="link-card card-1">
                <mat-card-content>
                  <a routerLink="/home-parking-requests">
                    <div class="icon-container">
                      <i class="bi bi-house-door"></i>
                    </div>
                    Cerere de parcare la domiciliu
                  </a>
                </mat-card-content>
              </mat-card> -->
              <!-- <mat-card class="link-card">
                <mat-card-content>
                  <a routerLink="/tickets">
                    <div class="icon-container">
                      <i class="bi bi-file-text"></i>
                    </div>
                    Tichete
                  </a>
                </mat-card-content>
              </mat-card> -->
            </div>
          </div>
        </mat-drawer-content>
      </mat-drawer-container>
    </div>
  </div>
</div>